import React, { Component } from "react";
import Aux from "../../hoc/Auxilliary";
import AdminHeader from "./AdminHeader";
import AdminLeftNav from "./AdminLeftNav";
import AdminMainContent from "./AdminMainContent/AdminMainContent";

class AdminContainer extends Component {
  render() {
    return (
      <Aux>
        <AdminHeader {...this.props} />
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-3 col-md-2 sidebar">
              <AdminLeftNav {...this.props} page={this.props.page} />
            </div>
            <div className="col-sm-9 col-sm-offset-3 col-md-10 col-md-offset-2 main main-content">
              <AdminMainContent {...this.props} page={this.props.page} />
            </div>
          </div>
        </div>
      </Aux>
    );
  }
}

export default AdminContainer;



// WEBPACK FOOTER //
// ./src/containers/Admin/Admin.js